import React, { memo } from 'react';

import { specialistShopLinks as defaultLinks } from 'constants/urls';

import SpecialistShopLink from './SpecialistShopLink';

import styles from './SpecialistShopsLinks.scss';

const links = [
  {
    name: 'myWaitrose',
    tracking: 'topnav_control_myWaitrose',
    url: 'https://www.waitrose.com/ecom/my-waitrose',
  },
].concat(defaultLinks);

const SpecialistShopsLinks = memo(() => (
  <div className={styles.wrapper} data-testid="specialist-shop-links">
    {links.map(link => (
      <SpecialistShopLink link={link} key={`specialistShops-desktop-${link.name}-link`} />
    ))}
  </div>
));

SpecialistShopsLinks.displayName = 'SpecialistShopsLinks';

export default SpecialistShopsLinks;
